import React from "react";
import { formatCurrency, intFormat } from "../../../../../../js/shared/utils";
import Loading from "../../../../../shared/Loading/Loading";

const SalesListHeaderBoxValue = props => {
	return (
		<div className="sales-list-header__boxes__content__values--box-value">
			{props.title}
			{props.isFetching && <Loading width="25" height="25" />}
			{(!props.isFetching && (
				<h4>
					<strong>
						{props.isDecimal
							? intFormat(props.value ? props.value : 0)
							: formatCurrency(props.value ? props.value : 0)}
					</strong>
				</h4>
			)) ||
				null}
		</div>
	);
};

export default SalesListHeaderBoxValue;
